define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CPCustomerUserModel = /** @class */ (function () {
        function CPCustomerUserModel(data) {
            this.Id = ko.observable(0);
            this.UserId = ko.observable();
            this.CustomerProfileId = ko.observable();
            this.FirstName = ko.observable();
            this.LastName = ko.observable();
            this.Email = ko.observable();
            this.PhoneNumber = ko.observable();
            this.Extension = ko.observable();
            this.RoleName = ko.observable();
            this.RoleId = ko.observable();
            this.Approved = ko.observable();
            this.UseManualReportsFiltering = ko.observable();
            this.IsLocked = ko.observable();
            this.EmailConfirmed = ko.observable();
            this.EnableCouterPath = ko.observable();
            this.EnableLdap = ko.observable();
            this.EnableCPLogin = ko.observable();
            this.CounterPathPassword = ko.observable();
            this.ResetCouterPathPasswords = ko.observable(false);
            this.CcsUserName = ko.observable();
            this.LdapPassword = ko.observable();
            this.OneClickPassword = ko.observable();
            this.InternalNote = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CPCustomerUserModel.Mapping, self);
            }
        }
        CPCustomerUserModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CPCustomerUserModel(options.data);
            }
        };
        return CPCustomerUserModel;
    }());
    return CPCustomerUserModel;
});
//# sourceMappingURL=CPCustomerUserModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CPCustomerUserModel.js
// module id = 172
// module chunks = 2